import { useTranslate } from '@va/localization';
import { CustomDomainRecord } from '@va/shared/api/custom-domains';
import { ActiveDomainItem } from './ActiveDomainItem';
import { CustomDomainAction } from './CustomDomainContextMenu';
import { InactiveDomainItem } from './InactiveDomainItem';
import { PendingDomainItem } from './PendingDomainItem';
import { ProvisioningStep } from './ProvisioningSteps';

export type CustomDomainActions = {
  active: (customDomain: CustomDomainRecord) => CustomDomainAction[];
  pending: (customDomain: CustomDomainRecord) => CustomDomainAction[];
  inactive: (customDomain: CustomDomainRecord) => CustomDomainAction[];
};

export const DomainsList = ({
  activeDomain,
  pendingDomain,
  inactiveDomains,
  actions,
  steps,
}: {
  activeDomain?: CustomDomainRecord | null;
  pendingDomain?: CustomDomainRecord | null;
  inactiveDomains?: CustomDomainRecord[];
  actions: CustomDomainActions;
  steps: ProvisioningStep[];
}) => {
  const translate = useTranslate();

  return (
    <div className='space-y-3'>
      {activeDomain && (
        <ActiveDomainItem
          label={translate('labels.customDomain')}
          value={activeDomain.domain}
          actions={actions.active(activeDomain)}
        />
      )}

      {pendingDomain && (
        <PendingDomainItem
          label={translate('labels.customDomain')}
          value={pendingDomain.domain}
          step={pendingDomain.step}
          status={pendingDomain.status}
          actions={actions.pending(pendingDomain)}
          steps={steps}
        />
      )}

      {inactiveDomains &&
        inactiveDomains.map((item) => (
          <InactiveDomainItem
            key={item.id}
            label={translate('labels.customDomain')}
            value={item.domain}
            status={item.status}
            step={item.step}
            actions={actions.inactive(item)}
            steps={steps}
          />
        ))}
    </div>
  );
};
